var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-datepicker',{attrs:{"size":_vm.size,"min-date":_vm.internalMinDate,"max-date":_vm.internalMaxDate,"position":_vm.position},model:{value:(_vm.internalDate),callback:function ($$v) {_vm.internalDate=$$v},expression:"internalDate"}})}
var staticRenderFns = []

export { render, staticRenderFns }